<template lang="pug" src="./block-section-background.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      active: false,
      show: false
    }
  },
  methods: {
    trigger ({ going, direction }) {
      if (going === 'in' && direction === 'top') {
        this.show === 0 ? this.show = 1 : this.show = 0
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/block/block-section-background/block-section-background.vue